<template>
  <v-app-bar app elevation="3">
    <img
      src="@/assets/logo.png"
      class="logo mr-auto"
      :class="{ 'in-room': inRoom }"
      @click="
        !inRoom &&
          $router.push({ path: `${role == 'superuser' ? '/superuser' : '/'}` })
      "
    />

    <v-btn
      rounded
      outlined
      small
      color="primary"
      class="mr-2"
      @click="$router.push({ path: '/shadow' })"
      v-if="!inRoom && isLoggedIn && role == 'superuser'"
    >
      <v-icon left small>mdi-eye</v-icon>
      {{ $t('watchPresentation') }}
    </v-btn>

    <v-btn  rounded outlined small depressed color="primary" v-if="isLoggedIn" @click="onLogout"
    >{{ $t('logout') }}
    <v-icon right small> mdi-logout </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState({
      role: (state) => state.auth.role,
    }),
    inRoom() {
      return this.$route.path.includes("/room/");
    },
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setAllowLeave"]),
    async onLogout() {
      await this.logout();

      if (this.inRoom) {
        this.setAllowLeave(true);
      }

      this.$router.push({ path: `/${this.$i18n.locale}/login` });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 100px;

  &:not(.in-room) {
    cursor: pointer;
  }

  
img {
  cursor: pointer;
}
}
</style>
